<template>
  <div class="homePage">
    <!-- <div v-html="homePage.content || ''" /> -->
    <quill-editor :content="homePage.content || ''" @focus="onEditorFocus($event)" />
    <div class="bottom">
      <van-checkbox
        v-model="checked"
        shape="square"
        label-disabled
        :checked-color="checked ? 'red' : '#07c160'"
        icon-size="26px"
      >
        <span style="color:red;font-weight:bold;">我已阅读</span>
      </van-checkbox>
      <van-button :color="checked ? 'red' : '#ccc'" size="small" @click="onRead">
        <p :class="checked ? 'into' : 'noInto'">开始购票</p>
      </van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { quillEditor } from 'vue-quill-editor';

export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    ...mapGetters(['homePage']),
  },
  methods: {
    onRead() {
      if (this.checked) {
        this.$emit('read');
      }
    },
    onEditorFocus(quill) {
      quill.enable(false);
    },
  },
};
</script>

<style lang="less" scoped>
.homePage {
  width: 100%;
  margin-bottom: 50px;
  position: absolute;
  top: 0;
  left: 0;
  /deep/ .quill-editor {
    .ql-toolbar {
      display: none;
    }
    .ql-snow {
      border: 0;
    }
  }
  .bottom {
    position: fixed;
    width: 100%;
    bottom: 60px;
    .van-checkbox {
      justify-content: center;
    }
    .van-button {
      width: 90%;
      margin: 10px 5% 0;
      border-radius: 5px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.into {
  background-color: red;
  color: white;
}
.noInto {
  color: black;
}
</style>
